import Vue from 'vue'
import { VNodeDirective } from 'vue/types/vnode'

interface ClickOutsideBindingArgs {
  handler: (e: Event) => void
  closeConditional?: (e: Event) => boolean
  include?: () => HTMLElement[]
}

interface ClickOutsideDirective extends VNodeDirective {
  value?: ((e: Event) => void) | ClickOutsideBindingArgs
}

export default Vue.directive('click-outside', {
  inserted: function (el: HTMLElement, binding, vnode) {
    if (!binding.value) return
    const app = document.querySelector('[data-app]') || document.body
    const onClick = (e: Event) => directive(e as PointerEvent, el, binding)
    app.addEventListener('click', onClick, true)
    ;(el as any)._clickOutside = onClick
  },
  unbind(el: HTMLElement) {
    if (!(el as any)._clickOutside) return

    const app = document.querySelector('[data-app]') || document.body
    app && app.removeEventListener('click', (el as any)._clickOutside, true)
    delete (el as any)._clickOutside
  },
})

function defaultConditional() {
  return true
}

function directive(
  e: PointerEvent,
  el: HTMLElement,
  binding: ClickOutsideDirective,
) {
  const handler =
    typeof binding.value === 'function' ? binding.value : binding.value!.handler
  const isActive =
    (typeof binding.value === 'object' && binding.value.closeConditional) ||
    defaultConditional

  if (!e || isActive(e) === false) return

  const elements = (
    (typeof binding.value === 'object' && binding.value.include) ||
    (() => [])
  )()
  elements.push(el)

  !elements.some(el => el.contains(e.target as Node)) &&
    setTimeout(() => {
      isActive(e) && handler && handler(e)
    }, 0)

  // return !e.path.includes(el)
}
